import {  createStore  } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

const vuex = createStore({
    plugins: [createPersistedState()],
    state: {},
    mutations: {},
    actions: {},
    getters: {}
})

 export default vuex
